import React, { useState, useEffect } from 'react';

const heightOptions = [
  `5'4"`, `5'5"`, `5'6"`, `5'7"`, `5'8"`, `5'9"`,
  `5'10"`, `5'11"`, `6'0"`, `6'1"`, `6'2"`, `6'3"`,
  `6'4"`, `6'5"`, `6'6"`, `6'7"`
];

const StepHeight = ({ data, setData, onNext, onPrev }) => {
  const [customFeet, setCustomFeet] = useState('');
  const [customInches, setCustomInches] = useState('');

  const handleSelect = (height) => {
    setData(prev => ({
      ...prev,
      height
    }));
    setCustomFeet('');
    setCustomInches('');
  };

  const handleCustomChange = () => {
    if (customFeet || customInches) {
      const formatted = `${customFeet}'${customInches}"`;
      setData(prev => ({
        ...prev,
        height: formatted
      }));
    }
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      height: null
    }));
    onNext();
  };

  // ✅ Auto-fill custom fields if height is custom
  useEffect(() => {
    const isCustom = data.height && !heightOptions.includes(data.height);
    if (isCustom) {
      const match = data.height.match(/^(\d+)'(\d*)"?$/);
      if (match) {
        setCustomFeet(match[1]);
        setCustomInches(match[2]);
      }
    }
  }, [data.height]);

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="selection-container">
              <h3 className="selection-title">How tall are you?</h3>

              <div className="selection-grid">
                {heightOptions.map((option) => (
                  <button
                    key={option}
                    className={`selection-btn ${data.height === option ? 'active' : ''}`}
                    onClick={() => handleSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>

              <div className="custom-height mt-3">
                <label>Something else:</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                  <input
                    type="text"
                    placeholder="ft"
                    value={customFeet}
                    onChange={(e) => setCustomFeet(e.target.value)}
                    onBlur={handleCustomChange}
                  />
                  <input
                    type="text"
                    placeholder="in"
                    value={customInches}
                    onChange={(e) => setCustomInches(e.target.value)}
                    onBlur={handleCustomChange}
                  />
                </div>
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="selection-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="selection-next-btn"
                  onClick={onNext}
                  disabled={!data.height}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepHeight;
